export enum InputType {
  Text,
  Password,
  Textarea,
  Number,
  Money,
  Select,
  Date,
  Radio,
  Checkbox,
  InputGroup,
  SwitchButton,
  SwitchButtonWithDescription,
  PhoneNumber,
  Info,
}
